import { render, staticRenderFns } from "./StageItem.vue?vue&type=template&id=4e4b7431&scoped=true&"
import script from "./StageItem.vue?vue&type=script&lang=js&"
export * from "./StageItem.vue?vue&type=script&lang=js&"
import style0 from "./StageItem.vue?vue&type=style&index=0&id=4e4b7431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b7431",
  null
  
)

export default component.exports